export default __webpack_public_path__ + "static/media/vladimir-haltakov-Efm5R4YroH4-unsplash.769a4f15.jpg";